<template>
    <div>
        <div class="app-title">
            <em-view-title ref="viewTitle" :crudState="$_emCommonListMixin_pathType"></em-view-title>
        </div>
        <section class="app-content" v-menu-permission="'list'">
            <div id="accordionFilter" class="content">
                <div class="card">
                    <div id="collapseOne" class="collapse show" aria-labelledby="headingOne"
                         data-parent="#accordionFilter">
                        <div class="card-body">
                            <form>
                                <em-filter :entity="modelName" ref="emListFilter"
                                           :$_em-custom-vuex-mixin_entity="$_emCustomVuexMixin_entity"
                                           :$_em-custom-vuex-mixin_filter="$_emCustomVuexMixin_filter"
                                           :$_em-custom-vuex-mixin_vo="$_emCustomVuexMixin_vo"
                                           @showEntityModalSelect="$_emCommonModalMixin_showModalSelectorByFilter"
                                           @showEntityMultipleModalSelect="$_emCommonModalMixin_showMultipleSelectorByFilter"></em-filter>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
            <div id="sithMesInventoryPackingBomResultTable" class="content">
                <div class="card my-1">
                    <div id="collapseTwo" class="collapse show" aria-labelledby="headingTwo"
                         data-parent="#accordionResult">
                        <div class="card-body">
                            <em-table :entity="modelName"
                                      :$_em-custom-vuex-mixin_entity="$_emCustomVuexMixin_entity"
                                      :$_em-custom-vuex-mixin_filter="$_emCustomVuexMixin_filter"
                                      :$_em-custom-vuex-mixin_vo="$_emCustomVuexMixin_vo"
                                      ref="emTable" exportDisabled :inlineActionsDisabled="prop_inline!=='1'"
                                      @showModalSelectorByNewRow="$_emCommonModalMixin_showModalSelectorByNewRow"
                                      @showModalSelectorByEditRow="$_emCommonModalMixin_showModalSelectorByEditRow">
                                <template #left-header>
                                    <b-button-group>
                                        <b-button
                                            :disabled="checkedItems.length < 1"
                                            variant="outline-primary"
                                            size="sm"
                                            @click="printLabel">打印物料码
                                        </b-button>
                                        <em-button
                                            type= 'search'
                                            class="btn btn-outline-primary btn-sm"
                                            custom-label="扫码识别"
                                            showName
                                            @click="openScannerDialog()"
                                        >
                                        </em-button>
                                        <em-button type="search"
                                            :disabled="actionDisabled('select')"
                                            custom-label="更新状态"
                                            :showName="true"
                                            v-bind:class="'btn btn-outline-primary btn-sm'"
                                            :busy="updatingStatus"
                                            @click="openUpdateDialog()"
                                        >
                                        </em-button>
                                    </b-button-group>
                                </template>
                            </em-table>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <em-modal-entity-selector ref="emModalEntitySelector"></em-modal-entity-selector>
        <el-dialog title="扫一扫" :center="true" :visible.sync="scannerVisible" @close="closeScannerDialog"
                   :close-on-click-modal='false' append-to-body>
            <qr-code-scanner ref="packingBomScanner" @getCodeData='getPackingMaterial'>
            </qr-code-scanner>
        </el-dialog>
        <el-dialog title="设置打包物料状态" :visible.sync="updateDialogVisible" :close-on-click-modal='false' append-to-body
               @close='clearMatStatus'>
            <el-select v-model="matStatus" placeholder="请选择">
                <el-option v-for="status in statusOptions" :key="status.value" :label="status.text" :value="status.value"></el-option>
            </el-select>

            <div slot="footer">
                <el-button @click="updateDialogVisible = false">取消</el-button>
                <el-button @click="updateMaterialStatus()" type="primary">确定</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
    // Author Lin
    // Date 2022-05-26 18:03:32

    import emCommonListMixin from "@/mixin/em/common/list";
    import emCustomVuexMixin from "@/mixin/em/customVuex";
    import qrCodeScanner from "@/components/QRCode/QRCodeScannerForInventory"
    import emCommonApiMixin from "@/mixin/em/common/api";

    export default {
        name: "sithMesInventoryPackingBomListView",
        mixins: [emCommonListMixin, emCustomVuexMixin, emCommonApiMixin],
        components: {qrCodeScanner},
        props: {
            //是否启用行编辑
            prop_inline: {
                type: String,
                default: "0"
            }
        },
        data() {
            return {
                scannerVisible: false,
                updatingStatus: false,
                updateDialogVisible: false,
                matStatus: '',
                statusOptions: [
                    { value: '1', text: '已到货' },
                    { value: '2', text: '已过103' },
                    { value: '3', text: '已退104' },
                    { value: '4', text: '已过105' },
                    { value: '5', text: '已退106' },
                    { value: '6', text: '已入库' }
                ]
            }
        },
        computed: {
            modelName() {
                return this.$_emRouterHelperMixin_entityName
            },
            checkedItems() {
                //这里要注意，如果filter和table使用了customVuex，这里要用checkedItems拼装首字母开头的customVuex name。不使用$refs.emTable是因为初始化时取不到，会报错
                return this.$store.state[this.modelName]["checkedItems"];
            },
            selectIds() {
                //这里要注意，如果filter和table使用了customVuex，这里要用checkedItems拼装首字母开头的customVuex name。不使用$refs.emTable是因为初始化时取不到，会报错
                return this.$store.state[this.modelName]["checkedItems"].join(",");
            },
        },
        methods: {
            actionDisabled(type) {
                    // 删除按钮在一条记录都没选的时候禁用
                if (type === "select") {
                        return this.checkedItems && this.checkedItems.length === 0;
                }
                    // 编辑按钮只在选择了1条记录的时候可用，其他情况下禁用
                else if (type === "selectOne") {
                    return this.checkedItems && this.checkedItems.length !== 1;
                }
            },
            openScannerDialog() {
                this.scannerVisible = true;
                setTimeout(() => {
                    this.$refs.packingBomScanner.openCamera('');
                },500);
            },
            closeScannerDialog() {
                this.$refs.packingBomScanner.closeCamera();
                this.$refs.packingBomScanner.resetOutputData();
                this.scannerVisible = false;
            },
            getPackingMaterial(data) {
                console.log("get qr code data:"+data);
                this.scannerVisible = false;
                let self = this;
                //检验二维码的数据格式
                try {
                    var obj = JSON.parse(data);
                    var poNumber = obj.PO;
                    var item = obj.PoItem;
                    var materialCode = obj['物料号'];
                    console.log(poNumber);
                    console.log(item);
                    console.log(materialCode);
                } catch (error) {
                    self.$message({
                    message: "无效的二维码",
                    type: "error",
                    });
                    return;
                }
                this.$refs.emListFilter.$_emCustomVuexMixin_setFilterAttribute('purchaseNumberFilter', poNumber);
                this.$refs.emListFilter.$_emCustomVuexMixin_setFilterAttribute('itemCodeFilter', item);
                this.$refs.emListFilter.$_emCustomVuexMixin_setFilterAttribute('materialCodeFilter', materialCode);
                this.$refs.emListFilter.doQuery();
            },
            openUpdateDialog() {
                this.updateDialogVisible = true;
            },
            clearMatStatus() {
                this.matStatus = '';
            },
            updateMaterialStatus() {
                let self = this;
                self.updatingStatus = true;
                let url = `${this.$_emApiMixin_entityBaseApi(this.modelName)}/updateMaterialStatus?ids=${this.selectIds}&status=${this.matStatus}`;
                this.$_emApiMixin_post(url, {})
                    .then((request) => {
                        if (request.status === 200) {
                            self.$message({
                            message: "设置成功",
                            type: "success",
                            });

                            self.$refs.emListFilter.doQuery();
                        } else {
                            self.$message({
                            message: "设置失败",
                            type: "error",
                            });
                        }
                    }).finally(() => {
                        self.updateDialogVisible = false;
                        self.updatingStatus = false;
                    })
            },
            printLabel() {
                let url = `${this.$_emApiMixin_entityBaseApi(this.modelName)}/getPackingBomPrintList?ids=${this.selectIds}`
                this.$_emApiMixin_post(url, {})
                    .then(response => {
                        this.$router.push({
                        name: "sithMesInventoryItemPrint",
                        query: response.data,
                        });
                    })
            },
        }
    };
</script>
